<template>
    <v-dialog v-model="dialog" max-width="300">
        <v-card color="green" dark>
            <v-card-text class="pt-2">
                Please stand by
                <v-progress-linear indeterminate color="white" class="mt-1"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['quiz_id'],
        data(){
            return {
                dialog: false,
            }
        },

        watch: {
            dialog: function (newVal) {
                if(newVal) {
                    this.fetchQuestions();
                }
            }
        },

        methods: {
            fetchQuestions() {
                this.$api('quizzes').getRandomQuestion(this.quiz_id).then((res) => {
                    this.dialog = false;
                    this.$emit('fetched', res.data.quizzes, res.data.salt)
                }).catch(() => {
                    this.$store.dispatch('alert', {type: 2, message: this.$t('quizzes.error_fetch')});
                })
            }
        }
    }
</script>